var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"scalerContainer",style:(_vm.styles)},[_vm._t("default",null,null,_vm.sizeData)],2)}
var staticRenderFns = []

export { render, staticRenderFns }